import * as React from 'react';
import cn from 'classnames';

import { ChannelKind, channelKindEntities } from 'shared/entities/channels';
import { IconSize } from 'shared/entities/components/Icon';
import {
  AvatarBorderColor,
  AvatarBorderSize,
  AvatarColor,
  AvatarSize,
  AvatarType
} from 'shared/newEntities/components/user/Avatar';

import Avatar from '../user/Avatar';

import './PhotoWithChannel.modules.scss';

type Props = {
  channelKind: ChannelKind;
  photoUrl: string | null;
  className?: string;
  name: string;
  size?: IconSize.XM | IconSize.L | IconSize.XL | IconSize.XXLM;
  borderColor?: AvatarBorderColor;
  borderSize?: AvatarBorderSize;
  defaultColor?: AvatarColor;
  /** Контент углового слота (статус-точка, @ и т.п.) */
  badge?: React.ReactNode;
};

export const PhotoWithChannel: React.FC<Props> = ({
  channelKind,
  className,
  name,
  photoUrl,
  size = IconSize.XM,
  borderColor,
  borderSize,
  defaultColor,
  badge
}: Props) => {
  const Icon = channelKindEntities[channelKind]?.Icon;

  const sideSize: AvatarSize = React.useMemo(() => {
    if (size === IconSize.XM) {
      return AvatarSize.xs;
    }

    if (size === IconSize.XL) {
      return AvatarSize.sm;
    }

    if (size === IconSize.XXLM) {
      return AvatarSize.lg;
    }

    return AvatarSize.s;
  }, [size]);

  return (
    <div
      styleName={cn('container', `container_${sideSize}`)}
      className={className}
    >
      <Avatar
        size={sideSize}
        type={photoUrl ? AvatarType.img : AvatarType.name}
        content={photoUrl || name}
        border={
          borderColor || borderSize
            ? { color: borderColor, size: borderSize }
            : undefined
        }
        color={defaultColor}
      />
      {Icon && (
        <Icon
          styleName={cn(
            'container__channel-logo',
            borderColor && `container__channel-logo_${borderColor}`
          )}
          iconSize={IconSize.XSS}
        />
      )}
      {badge && <div styleName="container__badge">{badge}</div>}
    </div>
  );
};

export default React.memo(PhotoWithChannel);
